const state = () => ({
  user_selected_for_individual_monitoring: null,
});

const getters = {
  userSelectedForIndividualMonitoring: (state) => state.user_selected_for_individual_monitoring,
};

const actions = {
  setUserSelectedForIndividualMonitoring({ commit }, user_selected_for_individual_monitoring) {
    commit('set_user_selected_for_individual_monitoring', user_selected_for_individual_monitoring);
  },
};

const mutations = {
  set_user_selected_for_individual_monitoring(state, user_selected_for_individual_monitoring) {
    state.user_selected_for_individual_monitoring = user_selected_for_individual_monitoring;
  },
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
